import UnsupportedBrowserDetection from './unsupportedBrowserDetection';

export const applyOnEdge = styleValue => (UnsupportedBrowserDetection.isEdge() ? styleValue : undefined);
